<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let isRounded = false;
    export let targetUrl = "";
    export let icon = "";
    export let linkText = "";
    export let imgSrc="";
    export let headerText="";
    export let mainContent="";
    export let buttonText="";
    export let modalLink = false;
    export let title = "";

    function ConfirmModal() {
      dispatch('handleContactModal', {text: 'true'});
    }

    function ConfirmFeedbackModal() {
      dispatch('handleFeedbackModal', {text: 'true'});
    }
   
</script>

{#if !isRounded}
    <div
        class="card h-100 card-body"
        style="padding: 2rem 3rem 2.5rem; text-align: center;">
        {#if imgSrc != ""}
            <div class="row">
                <div class="col-5 col-md-12">
                    <img class="mx-auto image"
                    src={imgSrc}
                    alt={headerText}
                    style="max-height:100px; width:auto; box-shadow: rgb(104 115 125 / 15%) 0px 4px 12px 0px;border-radius: 100%;margin-bottom: 1rem;" />
                </div>
                <div class="col-7 col-md-12">
                    <h3>{headerText}</h3>
                    <p>{mainContent}</p>    
                    {#if modalLink}
                        <a
                            class="btn btn-primary mt-auto"
                            href="#supportmodal"
                            role="button"
                            data-bs-toggle="modal"
                            data-bs-target="#supportmodal"
                            on:click={ConfirmModal}>
                            {buttonText}</a>
                    {:else}
                        <a href={targetUrl} target="_blank"class="btn btn-primary mt-auto">{buttonText}</a>
                    {/if} 
                </div>
            </div>
        {:else}
            <slot />
        {/if} 
    </div>
{:else}
    {#if modalLink}
        <div
            class="card cardhover"
            style="width: 100%;border-radius: 20px;cursor:pointer;"
            on:click={ConfirmFeedbackModal}
            title={title}>
            <div class="card-body text-center">
                <span class="material-icons" style="color: #011238;"> {icon} </span>
                <br />
                {linkText}
            </div>
        </div>
    {:else}
        <div
            class="card cardhover"
            style="width: 100%;border-radius: 20px;cursor:pointer;"
            on:click={() => window.open(targetUrl, '_blank')}
            title={title}>
            <div class="card-body text-center">
                <span class="material-icons" style="color: #011238;"> {icon} </span>
                <br />
                {linkText}
            </div>
        </div>
    {/if}
{/if}




  